import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchable"]

  connect() {
    this.searchMatchClasses = ["hidden"]
  }

  checkIfMatches() {
    if (!this.element.classList.contains("tabFiltered")) {
      return
    }

    const search_query = event.detail.search_query.toLowerCase()

    if (search_query.length == 0) {
      this.element.classList.remove(...this.searchMatchClasses)
      return
    }
    else {
      this.element.classList.add(...this.searchMatchClasses)
    }

    this.searchTargets(search_query)
  }

  searchTargets(search_query) {
    if (this.searchableTargets.map(searchable => this.search(searchable, search_query)).includes(true)) {
      this.element.classList.remove(...this.searchMatchClasses)
    }
  }

  search(target, query) {
    return target.textContent.toLowerCase().includes(query)
  }
}
